/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Img from 'react-image';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import jump from 'jump.js';
import { Link } from '@reach/router';

import { history } from '../../utils/router-history';

import Facebook from '../../img/Telus_One_page-25.png';
import LinkedIn from '../../img/Telus_One_page-26.png';
import Instagram from '../../img/Telus_One_page-27.png';
import Youtube from '../../img/Telus_One_page-28.png';
import Phone from '../../img/Telus_One_page-29.png';
import Email from '../../img/Telus_One_page-30.png';

import styles from './index.module.scss';
let cx = classNames.bind(styles);

const Footer = props => {
	const { t } = useTranslation();

	let navMenuClass = classNames({
		'cursor-pointer no-underline p-2 font-HelveticaNeueLTStd-Bold text-telus-purple text-base lg:text-xl w-auto': true,
	});

	return (
		<footer className={cx({ footer: true })}>
			<div className='container mx-auto py-10'>
				<div className='flex flex-col lg:flex-row w-full'>
					<div className='flex flex-col w-full lg:w-1/2 lg:pr-10  px-10 lg:p-0'>
						<div className='flex w-full'>
							<h1 className='text-telus-purple font-HelveticaNeueLTStd-Bold'>
								Follow us
							</h1>
						</div>
						<div className='flex flex-col w-full justify-start'>
							<div className='flex lg:flex-row justify-start items-center'>
								<a
									className={navMenuClass}
									href='https://www.facebook.com/TELUSsv'
									target='_blank'
									rel='noopener noreferrer'
								>
									<Img src={Facebook} className=' w-full lg:w-7/12' />
								</a>
								<a
									className={navMenuClass}
									href='https://www.linkedin.com/company/telusinternationalca/'
									target='_blank'
									rel='noopener noreferrer'
								>
									<Img src={LinkedIn} className=' w-full lg:w-7/12' />
								</a>
								<a
									className={navMenuClass}
									href='https://www.instagram.com/telussv/'
									target='_blank'
									rel='noopener noreferrer'
								>
									<Img src={Instagram} className=' w-full lg:w-7/12' />
								</a>
								<a
									className={navMenuClass}
									href='https://www.youtube.com/user/TELUSIntSV'
									target='_blank'
									rel='noopener noreferrer'
								>
									<Img src={Youtube} className=' w-full lg:w-7/12' />
								</a>
								<div className='mr-2'>
									<a className={navMenuClass} href='#'>
										@TELUSsv
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className='flex flex-col lg:flex-row w-full lg:w-1/2'>
						<div className='flex flex-col lg:w-1/2 px-10 lg:p-0 lg:justify-center lg:items-center'>
							<h1 className='text-telus-purple font-HelveticaNeueLTStd-Bold w-full lg:w-auto'>
								Contact us
							</h1>
							<Img
								src={Phone}
								className={cx({
									phone: true,
									'py-2 lg:m-0 lg:w-2/12 lg:py-2': true,
								})}
							/>
							<h1 className='text-telus-purple font-HelveticaNeueLTStd-Bold'>
								2523.8305
							</h1>
						</div>
						<div className='flex flex-col px-10 lg:px-0 w-full lg:w-1/2 lg:justify-center lg:items-center'>
							<Img src={Email} className={cx({
								phone: true,
								'py-2 lg:m-0 lg:w-2/12 lg:py-2': true,
							})} />
							<h1 className='text-white bg-telus-purple w-full text-center font-HelveticaNeueLTStd-Bold text-sm p-1 leading-tight m-0'>
								ties_talentacquisition.sv@telusinternational.com
							</h1>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
